export default "__VITE_ASSET__OFRmNTg___"